import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchChannelDetail = createAsyncThunk("fetchChannelDetail", async (id) => {
	const response = await axiosHttp.get(`channel/${id}`);
	return response.data.data;
});

const ChannelDetailsSlice = createSlice({
	name: "ChannelDetailsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchChannelDetail.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchChannelDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchChannelDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ChannelDetailsSlice.reducer;
